import _ from 'lodash';

import { isNullOrEmpty } from '../../utilities/stringUtil';
import { APPROVAL_STATUS_FIELDTREE } from '../../utilities/constants';

/**
 * 検索用パラメータを作成
 * @param {object}param:検索パラメーター
 * @return {object}searchParam:API通信用検索パラメーター
 * */
const createSearchFieldTreeCompanyBranchList = param => {
  const searchParam = Object.create(null);
  searchParam.offset = param.offset;
  if (!isNullOrEmpty(param.limit)) {
    searchParam.limit = String(param.limit);
  }

  if (!isNullOrEmpty(param.name)) {
    searchParam.name = String(param.name);
  }

  if (!isNullOrEmpty(param.companyBranchName)) {
    searchParam.company_branch_name = String(param.companyBranchName);
  }

  if (!isNullOrEmpty(param.jvCompanyBranchId)) {
    searchParam.jv_company_branch_id = Number(param.jvCompanyBranchId);
  }

  if (!isNullOrEmpty(param.hideWorkEndFlag)) {
    searchParam.hide_work_end_flag = Number(param.hideWorkEndFlag);
  }

  if (!isNullOrEmpty(param.deduplicationflag)) {
    searchParam.deduplicationflag = Number(param.deduplicationflag);
  }

  if (!isNullOrEmpty(param.primaryDisplayFlag)) {
    searchParam.primary_display_flag = Number(param.primaryDisplayFlag);
  }
  return searchParam;
};

export const getKeyApprovalFlagById = id => {
  const data = _.find(APPROVAL_STATUS_FIELDTREE, ['id', id]);
  return _.get(data, 'key');
};
/**
 * 施工体系関連で利用するビジネスロジック格納クラス
 * */
const FieldTreesService = {
  createSearchFieldTreeCompanyBranchList,
};

export default FieldTreesService;



// WEBPACK FOOTER //
// ./src/services/fieldTrees/FieldTreesService.js